module.exports = __webpack_public_path__ + "static/img/HYUNDAI.a1d1b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/HYUNDAI.png
// module id = WX01
// module chunks = 1